<template>
  <div class="w-full mt-3">
    <diffInput
      type="select"
      :optList="returnableOrders"
      v-model="selectedOrderModel"
      title="İade Edilecek Sipariş"
      :required="true"
      :loading="loading"
      :disabled="loading"
      placeholder="Sipariş seçiniz..."
    />
  </div>
</template>

<script>
import axios from "axios";
import { planning } from "@/networking/urlmanager";
import diffInput from "@/components/general/diffInput.vue";

export default {
  name: "ReturnableOrderSelect",
  components: {
    diffInput,
  },
  props: {
    selectedOrder: {
      type: [String, Number],
      default: null,
    },
    sourceFilter: {
      type: String,
      default: null, // null = hepsi, 'spot' = sadece spot, 'bulk' = sadece toplu
    },
  },
  data() {
    return {
      returnableOrders: [],
      loading: false,
    };
  },
  computed: {
    selectedOrderModel: {
      get() {
        return this.selectedOrder;
      },
      set(value) {
        this.$emit("update:selectedOrder", value);
        // Seçilen siparişin detaylarını emit et
        const selectedOrderDetail = this.returnableOrders.find((order) => order.id === value);
        if (selectedOrderDetail) {
          this.$emit("orderSelected", selectedOrderDetail);
        }
      },
    },
  },
  mounted() {
    this.fetchReturnableOrders();
  },
  methods: {
    async fetchReturnableOrders() {
      this.loading = true;
      try {
        const response = await axios.get(planning.getReturnableOrders, {
          headers: {
            Authorization: "Bareer " + this.$store.state.userData.token,
          },
        });
        if (response.data && response.data.data) {
          let orders = response.data.data;
          // sourceFilter varsa sadece o tipteki siparişleri göster
          if (this.sourceFilter) {
            orders = orders.filter((order) => (order.sourceType || 'spot') === this.sourceFilter);
          }
          this.returnableOrders = orders.map((order) => ({
            id: order.id,
            name: order.displayName || `${order.orderNo} - ${order.customer}`,
            orderNo: order.orderNo,
            customer: order.customer,
            receivedName: order.receivedName,
            deliveredName: order.deliveredName,
            productType: order.productType,
            amount: order.amount,
            unitType: order.unitType,
            sourceType: order.sourceType || 'spot',
          }));
        }
      } catch (error) {
        console.error("İade edilebilecek siparişler yüklenirken hata:", error);
        this.$swal.fire({
          icon: "error",
          title: "Hata",
          text: "İade edilebilecek siparişler yüklenemedi. Lütfen tekrar deneyin.",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>